import React from 'react';
import { Box, SimpleGrid, Skeleton, SkeletonCircle, SkeletonText, FormControl } from '@chakra-ui/react';
import Banner1 from '../components/Banner1';

const AppSkeleton = () => {
  return (
    <main>
      <Banner1 />
      <Box display="flex" flexDirection={{ base: 'column', lg: 'row' }} pl={10} width={{ base: '100%', lg: '80%' }} gap="5" margin="auto" mt="5">
        <Box w={{ base: '100%', lg: '80%' }}>
          <Skeleton height="50px" mb={4} />
          <Skeleton height="60px" mb={4} />

          <Skeleton height="40px" mb={4} />

          <FormControl display="flex" justifyContent="center">
            <SimpleGrid columns={[1, 1, 2, 2, 4, 4]} gap={6} width="100%" boxShadow="md" p="6" rounded="md" borderWidth={1} mt={4}>
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton height="60px" key={index} />
              ))}
            </SimpleGrid>
          </FormControl>

          <SimpleGrid columns={[1]} spacing={4} mt={5} width={['100%']}>
            <Skeleton height="24px" width="200px" mb={4} />
            {Array.from({ length: 8 }).map((_, index) => (
              <Box key={index} display="flex" flexDirection="row" gap={4} p={4} borderWidth="1px" borderRadius="xl" boxShadow="md">
                <SkeletonCircle size="16" />
                <Box flex="1">
                  <Skeleton height="20px" width="70%" />
                  <SkeletonText mt="4" noOfLines={2} spacing="4" />
                  <Skeleton height="20px" width="50%" mt={2} />
                </Box>
              </Box>
            ))}
          </SimpleGrid>
        </Box>

        <Box w={{ base: '90%', lg: '20%' }} minWidth={'300px'}>
          <Skeleton height="50px" mb={4} />
          <Skeleton height="60px" mb={4} />
          <Skeleton height="40px" mb={4} />
          <Skeleton height="40px" mb={4} />
          <Skeleton height="40px" mb={4} />
          <Skeleton height="40px" mb={4} />
        </Box>
      </Box>
      
    </main>
  );
};

export default AppSkeleton;
